import { SafetyLocalStorage } from '@mail-core/std';
import { Text } from '@vkontakte/vkui';
import { ReactComponent as Arrow } from 'img/quota-landing/family/spaceToEach/arrow.svg';
import React, { type RefObject, forwardRef, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { isRebrandingQuotaLanding } from 'reactApp/appHelpers/featuresHelpers';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { FloatingTooltip } from 'reactApp/ui/FloatingTooltip/FloatingTooltip';
import { ETooltipAppearance, ETooltipPlacement, ETooltipSize } from 'reactApp/ui/FloatingTooltip/FloatingTooltip.types';
import { sendDwh } from 'reactApp/utils/ga';

import styles from './FamilySpaceToEachWelcomeTooltip.css';

interface FamilySpaceToEachWelcomeTooltipProps {
    setShowTooltip: React.Dispatch<React.SetStateAction<boolean>>;
}

export const FAMILY_SPACE_TO_EACH_WELCOME_ITEM_ID = 'family-space-to-each-welcome-tooltip';

export const FamilySpaceToEachWelcomeTooltip = forwardRef<HTMLDivElement, FamilySpaceToEachWelcomeTooltipProps>(
    ({ setShowTooltip }, ref) => {
        const email = useSelector(UserSelectors.getEmail);
        const storage = new SafetyLocalStorage({});

        const onClose = useCallback(() => {
            sendDwh({
                eventCategory: 'tooltip',
                action: 'close',
                dwhData: {
                    name: 'fam_price_not_change',
                },
                dwh_enabled: true,
            });
            setShowTooltip(false);
            sessionStorage.removeItem(`${FAMILY_SPACE_TO_EACH_WELCOME_ITEM_ID}-show`);
            storage.setItem(`${email}|${FAMILY_SPACE_TO_EACH_WELCOME_ITEM_ID}`, 'true');
        }, [email, setShowTooltip]);

        const onShow = useCallback(() => {
            sendDwh({
                eventCategory: 'tooltip',
                action: 'show',
                dwhData: {
                    name: 'fam_price_not_change',
                },
                dwh_enabled: true,
            });
        }, []);

        return (
            <FloatingTooltip
                target={ref as RefObject<HTMLDivElement>}
                appearance={ETooltipAppearance.blue}
                placement={ETooltipPlacement.bottom}
                allowFlip={false}
                size={ETooltipSize.fit}
                qaId="family-space-to-each-tooltip"
                usePortal
                belowSticky
                isRebrandingQuotaLanding={isRebrandingQuotaLanding}
                leftOffset={69}
                topOffset={37}
                closeOnOutsideClick={false}
                className={styles.rootWrapper}
                arrowClassName={styles.arrow_hidden}
                contentClassName={styles.content}
                closeClassName={styles.close}
                onClose={onClose}
                onShow={onShow}
            >
                <Text weight="2" className={styles.text}>
                    Число участников меняется, а цена —&nbsp;нет 🔥
                </Text>
                <Arrow className={styles.arrow} />
            </FloatingTooltip>
        );
    }
);

FamilySpaceToEachWelcomeTooltip.displayName = 'FamilySpaceToEachWelcomeTooltip';
